import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";

export class DjPsychoNoWinRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return (DjPsycho.model.noWinCount === 5);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                DjPsycho.model.noWinCount = 0;
                controller.finish();
            }
        });
        tl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });
        }, 0);

        tl.add(DjPsycho.noWinView.showNoWin());
    }

    private onSkip(tl: TimelineLite): void {
        tl.totalProgress(1);

        // #170
        DjPsycho.noWinView.skip();
    }
}